import { motion } from "framer-motion";
import { AppLayout } from "../../../layout/AppLayout";
import { useContext, useEffect, useRef } from "react";
import { Crown, Live, Profile } from "../../../components/svg/GeneralIcons";
import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import clsx from "clsx";
import Header from "../../../components/world/rmc/Header";
import { CheckSuccessModal } from "../../../modules/world/rmc/modals/checkSuccess";
import { useBrandLive } from "../../../api/brands/useBrandLive";
import { Loader } from "../../../components/loader/Loader";
import { useCountdownTimer } from "../../../hooks/useTimerCountdown";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useGetBrandPrizes } from "../../../api/getBrandPrizes";
import { CardLoader } from "../../../components/loader/CardLoader";
import { RmcContext } from "../../../components/context/RmcContext";
import { useGetAudience } from "../../../api/audience/useGetAudience";
import { useGenerateBrand } from "../../../api/useGenerateBrand";
import { UserContext } from "../../../components/context/UseContext";
import { FaPlane } from "react-icons/fa";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
    partialVisibilityGutter: 120,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    partialVisibilityGutter: 120,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    partialVisibilityGutter: 120,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 120,
  },
};

// const quests = [
//   {
//     reward: "Headphones",
//     description:
//       "Win a next-gen console to keep the fun going even after the trivia ends.",
//   },
//   {
//     reward: "Headphones",
//     description:
//       "Win a next-gen console to keep the fun going even after the trivia ends.",
//   },
// ];

function WorldLive() {
  dayjs.extend(customParseFormat);
  const {
    handleGetBrandLive,
    liveData,
    isLoading,
    handleJoinBrandLive,
    isJoining,
    isOpen,
    setIsOpen,
    joinedData,
  } = useBrandLive();
  const { token } = useContext(UserContext);
  const { brandId, slug, worldBranch } = useContext(RmcContext);
  const { GetAudience } = useGetAudience();
  const hasCalledRef = useRef(false);
  const { getBrandPrizes, brandPrizes, loading } = useGetBrandPrizes();
  const {
    generateBrand,
    data: brandData,
    loading: isPending,
  } = useGenerateBrand();
  useEffect(() => {
    if (brandId && !hasCalledRef.current) {
      hasCalledRef.current = true;
      getBrandPrizes(brandId);
      handleGetBrandLive(brandId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId]);

  useEffect(() => {
    if (brandId) {
      generateBrand({
        token: token,
        brand_id: brandId,
        is_link: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId]);

  const primaryColor = brandData?.data?.brand?.secondary_color ?? "#FFD700";
  const data = liveData?.live;

  const { timeLeft, isActive, hasEnded, yetToStart } = useCountdownTimer(
    data?.start_time || "12:00:00",
    data?.end_time || "14:00:00",
  );

  const startTime = data?.start_time
    ? dayjs(data?.start_time, "HH:mm:ss").format("ha")
    : "12pm";
  const endTime = data?.end_time
    ? dayjs(data?.end_time, "HH:mm:ss").format("ha")
    : "2pm";

  if (isPending || loading || isLoading) {
    return (
      <div className="h-[100dvh] bg-[#111522] flex items-center justify-center">
        <Loader type="spinningBubbles" color="#fff" />
      </div>
    );
  }

  return (
    <AppLayout
      bg={"!bg-[#111522]"}
      navBg={"!bg-[#111522]"}
      firstText={brandData?.data?.brand?.name ?? "Kingdom Quest"}
      secondText={"I'm Live"}
      thirdText={"Achievements"}
      fourthText={"Profile"}
      firstIcon={
        brandData?.data?.brand?.name?.toLowerCase().includes("airpeace") ? (
          <FaPlane className="w-5 h-5 -rotate-45" />
        ) : (
          <Crown className={"w-5 h-5"} />
        )
      }
      secondIcon={<Live className={"w-5 h-5"} />}
      fourthIcon={<Profile className={"w-5 h-5"} />}
      activeColor={brandData?.data?.brand?.secondary_color ?? "#FFD700"}
      inactiveClass={"text-[#FFFFFFBF]"}
      firstLink={`${slug}/home`}
      secondLink={`${slug}/live${
        worldBranch?.value ? `?branch_id=${worldBranch.value}` : ""
      }`}
      thirdLink={`${slug}/achievements`}
      fourthLink={`${slug}/profile`}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 3, delay: 0.4 }}
        className="relative pb-20"
      >
        <motion.div className="relative rounded-b-[25px]">
          <Header customBgColor={primaryColor} />
        </motion.div>

        {isLoading ? (
          <div className="mt-10 px-5 ">
            <div>
              <div className="h-24 bg-gray-600 rounded animate-pulse mb-3"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse mb-2"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse mb-2"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse w-3/4 mb-2"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse w-3/4"></div>
            </div>
            <div>
              <div className="h-24 bg-gray-600 rounded animate-pulse mt-8 mb-3"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse mb-2"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse mb-2"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse w-3/4 mb-2"></div>
              <div className="h-6 bg-gray-600 rounded animate-pulse w-3/4"></div>
            </div>
          </div>
        ) : (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 3, delay: 0.4 }}
              className="px-5 mt-3"
            >
              <motion.h3
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="tracking-tighter text-2xl font-semibold text-white mx-0"
              >
                I'm Live
              </motion.h3>
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.8 }}
                className="text-xs font-medium mt-1 text-[#FFFFFF80]"
              >
                Check in daily between{" "}
                <span
                  style={{ color: primaryColor }}
                >{`${startTime} - ${endTime}`}</span>{" "}
                for{" "}
                <span style={{ color: primaryColor }}>
                  ₦{liveData?.live?.checkIn_amount}{" "}
                </span>
                to enter the draw and stand a chance to win amazing prizes in
                the draw!
              </motion.p>
            </motion.div>
            <motion.div className="px-5 pt-8">
              <div className="flex items-center justify-between gap-4">
                <div className="w-1/3">
                  <div className="flex items-center justify-center bg-[#1A1F33] border border-[#252B41] rounded-[11px] text-xl font-bold text-white w-full py-4">
                    {timeLeft.hours}
                  </div>
                  <p className="text-center text-sm text-[#FFFFFF80] mt-3">
                    Hours
                  </p>
                </div>
                <div className="w-1/3">
                  <div className="flex items-center justify-center bg-[#1A1F33] border border-[#252B41] rounded-[11px] text-xl font-bold text-white w-full py-4">
                    {timeLeft.minutes}
                  </div>
                  <p className="text-center text-sm text-[#FFFFFF80] mt-3">
                    Minutes
                  </p>
                </div>
                <div className="w-1/3">
                  <div className="flex items-center justify-center bg-[#1A1F33] border border-[#252B41] rounded-[11px] text-xl font-bold text-white w-full py-4">
                    {timeLeft.seconds}
                  </div>
                  <p className="text-center text-sm text-[#FFFFFF80] mt-3">
                    Seconds
                  </p>
                </div>
              </div>
              <button
                disabled={data?.hasCheckedIn || hasEnded || yetToStart}
                onClick={() => handleJoinBrandLive(data?.brand_id, data?.id)}
                className={clsx(
                  isActive ? "cursor-pointer" : "cursor-not-allowed opacity-50",
                  "mt-10 mb-8 h-[60px] w-full font-semibold text-lg rounded-[10px] flex items-center justify-center",
                )}
                style={{ backgroundColor: primaryColor }}
              >
                {isJoining ? (
                  <Loader type="bubbles" />
                ) : hasEnded || yetToStart ? (
                  "Check-in Closed"
                ) : data?.hasCheckedIn ? (
                  `Checked-In`
                ) : (
                  `Check-In(₦${liveData?.live?.checkIn_amount})`
                )}
              </button>
            </motion.div>
            <motion.div className="p-5 mt-11 bg-[#1A1F33] mx-5 rounded-[10px] h-[148px]">
              <div className="flex flex-col justify-between h-full">
                <div className="flex items-center justify-between">
                  <p className="text-center text-base font-semibold text-[#FFFFFF75]">
                    {liveData?.live?.live_text ?? "Your church"}
                  </p>
                  <div className="w-4 h-4 bg-[#00FF5E] rounded-full" />
                </div>
                <div>
                  <p className="text-3xl font-bold text-white">
                    {liveData?.live_count}
                  </p>
                  <p className="text-sm font-semibold text-[#FFFFFFBF] mt-1">
                    Members Live
                  </p>
                </div>
              </div>
            </motion.div>
            <motion.h3
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4, delay: 0.6 }}
              className="tracking-tighter text-xl font-semibold mt-11 text-white mx-5"
            >
              Prizes on this Week's Draw
            </motion.h3>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4, delay: 0.6 }}
              className="text-xs font-medium mt-1 text-[#FFFFFF80] mx-5"
            >
              Check in daily between {`${startTime} - ${endTime}`} and stand a
              chance to win amazing prizes. Each correct answer brings you
              closer to victory. The more you check in, the more you win!
            </motion.p>
            {loading ? (
              <div className="mt-5">
                <CardLoader
                  count={2}
                  className={"h-[90px]"}
                  innerClass={"h-[90px]"}
                />
              </div>
            ) : brandPrizes?.data?.length > 0 ? (
              <Carousel
                autoPlay={false}
                responsive={responsive}
                arrows={false}
                partialVisible={true}
                ssr={true}
                className="mt-5"
              >
                {brandPrizes.data.map((x, i) => {
                  const isEven = i % 2 === 0;
                  return (
                    <div
                      key={i}
                      className={clsx(
                        "p-5 rounded-[10px] flex items-center gap-5 justify-between mx-4",
                        isEven ? "bg-[#FAFAFA]" : "bg-[#F8DBD8]",
                      )}
                    >
                      <div className="flex flex-col justify-between gap-4">
                        <p className="font-semibold text-sm text-[#000000] line-clamp-1">
                          {x.name}
                        </p>
                        <p className="text-xs leading-tight font-medium text-[#00000080]">
                          {x.description}
                        </p>

                        {/* <button className="text-[#000000] text-[10px] font-semibold text-left flex items-center gap-3">
                      Join quest
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1849_5233)">
                          <path
                            d="M9.0625 5C9.0625 2.76 7.24 0.9375 5 0.9375C2.76 0.9375 0.9375 2.76 0.9375 5C0.9375 7.24 2.76 9.0625 5 9.0625C7.24 9.0625 9.0625 7.24 9.0625 5ZM8.4375 5C8.4375 6.90219 6.90219 8.4375 5 8.4375C3.09781 8.4375 1.5625 6.90219 1.5625 5C1.5625 3.09781 3.09781 1.5625 5 1.5625C6.90219 1.5625 8.4375 3.09781 8.4375 5ZM6.53312 5L6.31844 4.775L4.44344 2.9L3.99344 3.35L5.64469 5L3.99469 6.65L4.44375 7.1L6.31875 5.225L6.53312 5Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1849_5233">
                            <rect
                              width="10"
                              height="10"
                              fill="white"
                              transform="translate(10) rotate(90)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </button> */}
                      </div>
                      <img
                        className="w-[94px] object-cover"
                        src="/image/headphone.png"
                        alt="banner"
                        loading="lazy"
                      />
                    </div>
                  );
                })}
              </Carousel>
            ) : (
              <div className="mt-5 px-4">
                <div className="p-5 rounded-[10px] bg-[#FAFAFA] text-center">
                  <p className="text-[#00000080] text-sm">
                    No prizes available at the moment
                  </p>
                </div>
              </div>
            )}
          </>
        )}
      </motion.div>

      {isOpen && (
        <CheckSuccessModal
          data={joinedData?.ticket}
          primaryColor={primaryColor}
          handleCloseModal={() => {
            GetAudience(brandId, false);
            handleGetBrandLive(brandId);
            setIsOpen(false);
          }}
        />
      )}
    </AppLayout>
  );
}

export default WorldLive;
